import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import { checkPermission } from "../../../core/permissons/CheckPermissons";

const route = all_routes;

const Users = () => {

  const navItems1 = [
    { label: "View Uers", icon: "ti ti-layout-dashboard", link: route.ViewUsers, permission: "ROLE_GET_USERS" },
    { label: "Add Users", icon: "ti ti-car", link: route.AddUsers, permission: "ROLE_ADD_USERS" },
      ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">Administration/Users/View Users</h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
                <div className="card">
                                        <div className="card-body pb-0 pt-2">
                                        <ul className="nav nav-tabs nav-tabs-bottom">
                                          {navItems1.map((item, index) =>
                                          item.permission && checkPermission(item.permission) ? (
                                            <li className="nav-item me-item" key={index}>
                                            <Link
                                              to={item.link}
                                              className={`nav-link px-0 ${index === 0 ? "active" : ""}`}
                                            >
                                              <i className={item.icon}></i> {item.label}
                                            </Link>
                                            </li>
                                          ) : null
                                          )}
                                        </ul>
                                        </div>
                                      </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;
